import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 566.93 146.94"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "data-name": "Layer 2" }, [
      _createElementVNode("path", {
        d: "M424.2 146.94h41.35l13.22-57.72a192.492 192.492 0 0 1-46.59 22.66l-7.98 35.06ZM316.94 81.01c9.94.62 19.91.41 29.81-.63l-6.93-50-22.88 50.63Zm-92.77-23.07c18.05 8.19 34.21 13.85 52.05 17.63L313.37.01h58.57l13.64 74.93c13.82-3.09 27.17-8.03 39.67-14.69L388.94.01h28.33c1.67-.11 3.32.41 4.62 1.47l42.61 34a356.804 356.804 0 0 0 37.57-32.32c2.52-2.52 4.2-3.15 7.77-3.15h57.09c-56.67 59.4-106 94.66-164.35 109.15l-10.28 2.51 6.5 35.27H356l-4.19-30.44c-16.75.91-33.54.28-50.17-1.89l-14.69 32.33H241l21.83-44.29-2.98-1.64a77.997 77.997 0 0 1-35.68-43.07Zm-89.21 89h93.83l8.39-35.69h-53.1L209.48.01h-40.93l-33.59 146.93Zm-76.61-76 8.4-36.52h19.1c9.86 0 17.84 2.94 17.84 15.54 0 10.91-8 21-24.56 21l-20.78-.02ZM0 146.94h40.93l9.65-42.4h31.49c39.67 0 63.39-30 63.39-59.61 0-30.23-21.2-44.92-52.9-44.92h-59L0 146.94Z",
        "data-name": "Layer 1-2",
        style: {"fill":"#ec0c31"}
      })
    ], -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "OG-logo"}) } }